import { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

import Sidebar from "../../components/Dashboard/EmployeeSidebar";

import { fetchLessons } from "../../api/lessons/students";
import { fetchCourses, fetchEnrolledCourses } from "../../api/courses/students";

import cardPlaceholderImg from "../../images/image.png";
import placeholderImage from "../../images/placeholder.png";

import "./index.css";

import Navbar from "../../components/Navbar";
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } from "react-dom";

function OverviewIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#FCFCFC" />
      <path d="M13.0611 29.0451L13.5019 28.4383L13.0611 29.0451ZM11.9549 27.9389L12.5617 27.4981L11.9549 27.9389ZM28.0451 27.9389L27.4383 27.4981L28.0451 27.9389ZM26.9389 29.0451L26.4981 28.4383L26.9389 29.0451ZM26.9389 10.9549L26.4981 11.5617L26.9389 10.9549ZM28.0451 12.0611L27.4383 12.5019L28.0451 12.0611ZM13.0611 10.9549L13.5019 11.5617L13.0611 10.9549ZM11.9549 12.0611L12.5617 12.5019L11.9549 12.0611ZM16 23.25C15.5858 23.25 15.25 23.5858 15.25 24C15.25 24.4142 15.5858 24.75 16 24.75V23.25ZM24 24.75C24.4142 24.75 24.75 24.4142 24.75 24C24.75 23.5858 24.4142 23.25 24 23.25V24.75ZM16 19.25C15.5858 19.25 15.25 19.5858 15.25 20C15.25 20.4142 15.5858 20.75 16 20.75V19.25ZM24 20.75C24.4142 20.75 24.75 20.4142 24.75 20C24.75 19.5858 24.4142 19.25 24 19.25V20.75ZM16 15.25C15.5858 15.25 15.25 15.5858 15.25 16C15.25 16.4142 15.5858 16.75 16 16.75V15.25ZM19 16.75C19.4142 16.75 19.75 16.4142 19.75 16C19.75 15.5858 19.4142 15.25 19 15.25V16.75ZM28.25 19V21H29.75V19H28.25ZM11.75 21V19H10.25V21H11.75ZM20 29.25C18.1084 29.25 16.75 29.249 15.698 29.135C14.6601 29.0225 14.0099 28.8074 13.5019 28.4383L12.6202 29.6518C13.4266 30.2377 14.3709 30.5 15.5365 30.6263C16.688 30.751 18.1418 30.75 20 30.75V29.25ZM10.25 21C10.25 22.8582 10.249 24.312 10.3737 25.4635C10.5 26.6291 10.7623 27.5734 11.3482 28.3798L12.5617 27.4981C12.1926 26.9901 11.9775 26.3399 11.865 25.302C11.751 24.25 11.75 22.8916 11.75 21H10.25ZM13.5019 28.4383C13.1411 28.1762 12.8238 27.8589 12.5617 27.4981L11.3482 28.3798C11.7028 28.8679 12.1321 29.2972 12.6202 29.6518L13.5019 28.4383ZM28.25 21C28.25 22.8916 28.249 24.25 28.135 25.302C28.0225 26.3399 27.8074 26.9901 27.4383 27.4981L28.6518 28.3798C29.2377 27.5734 29.5 26.6291 29.6263 25.4635C29.751 24.312 29.75 22.8582 29.75 21H28.25ZM20 30.75C21.8582 30.75 23.312 30.751 24.4635 30.6263C25.6291 30.5 26.5734 30.2377 27.3798 29.6518L26.4981 28.4383C25.9901 28.8074 25.3399 29.0225 24.302 29.135C23.25 29.249 21.8916 29.25 20 29.25V30.75ZM27.4383 27.4981C27.1762 27.8589 26.8589 28.1762 26.4981 28.4383L27.3798 29.6518C27.8679 29.2972 28.2972 28.8679 28.6518 28.3798L27.4383 27.4981ZM20 10.75C21.8916 10.75 23.25 10.751 24.302 10.865C25.3399 10.9775 25.9901 11.1926 26.4981 11.5617L27.3798 10.3482C26.5734 9.76232 25.6291 9.50001 24.4635 9.37373C23.312 9.24897 21.8582 9.25 20 9.25V10.75ZM29.75 19C29.75 17.1418 29.751 15.688 29.6263 14.5365C29.5 13.3709 29.2377 12.4266 28.6518 11.6202L27.4383 12.5019C27.8074 13.0099 28.0225 13.6601 28.135 14.698C28.249 15.75 28.25 17.1084 28.25 19H29.75ZM26.4981 11.5617C26.8589 11.8238 27.1762 12.1411 27.4383 12.5019L28.6518 11.6202C28.2972 11.1321 27.8679 10.7028 27.3798 10.3482L26.4981 11.5617ZM20 9.25C18.1418 9.25 16.688 9.24897 15.5365 9.37373C14.3709 9.50001 13.4266 9.76232 12.6202 10.3482L13.5019 11.5617C14.0099 11.1926 14.6601 10.9775 15.698 10.865C16.75 10.751 18.1084 10.75 20 10.75V9.25ZM11.75 19C11.75 17.1084 11.751 15.75 11.865 14.698C11.9775 13.6601 12.1926 13.0099 12.5617 12.5019L11.3482 11.6202C10.7623 12.4266 10.5 13.3709 10.3737 14.5365C10.249 15.688 10.25 17.1418 10.25 19H11.75ZM12.6202 10.3482C12.1321 10.7028 11.7028 11.1321 11.3482 11.6202L12.5617 12.5019C12.8238 12.1411 13.1411 11.8238 13.5019 11.5617L12.6202 10.3482ZM16 24.75H24V23.25H16V24.75ZM16 16.75H19V15.25H16V16.75ZM16 20.75H20V19.25H16V20.75ZM20 20.75H24V19.25H20V20.75Z" fill="#131313" />
    </svg>
  )
}

function ViewCourseIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#FCFCFC" />
      <path d="M27.75 19.7257H12.75" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M21.7002 13.7013L27.7502 19.7253L21.7002 25.7503" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

function EmployeeCourses() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [lessons, setLessons] = useState({});
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  useEffect(async () => {
    try {
      const res = await fetchEnrolledCourses();
      setEnrolledCourses(res);
    } catch (err) { // TODO: handle error
      console.log(err)
    }
  }, []);

  useEffect(async () => {
    const obj = {};
    courses.forEach(async ({ id, hidden }) => {
      if (!hidden) {
        try {
          const res = await fetchLessons(id);
          if (res) {
            obj[id] = res
          }
        } catch (err) {
          console.log(err);
        }
      }
    });
    setLessons(obj)
  }, [courses]);

  useEffect(async () => {
    const arr = [];
    const studentLibraryId = localStorage.getItem('studentEnrolledLibraryId');
    const res = await fetchCourses(studentLibraryId);

    let enrolled = false;
    res.forEach(a => {
      enrolled = false;
      enrolledCourses.forEach(b => {
        if (!a.hidden && ((a.id == b.id) && (a.library_id == b.library_id))) {
          arr.push({
            ...a,
            enrolled: true
          })
          enrolled = true;
          return; // continue
        }
      });
      // Prevents duplicated elements
      if (!a.hidden && !enrolled) {
        arr.push(a);
      }
    });
    setCourses(arr);
  }, [enrolledCourses]);

  return (
    courses.map(({
      id,
      title,
      author_name,
      pretty_created_at,
      hero_image_url,
      author_profile_image_url,
      enrolled,
    }) => {
      return (
        <div className="EmployeeDashboardCourse">
          <div
            className="Card"
          >
            <div
              className="CardImg"
              style={{ backgroundImage: `url(${hero_image_url || cardPlaceholderImg})` }}
            >
              <div className="CardActions">
                {enrolled ?
                  <div
                    className="CardViewCourse"
                    onClick={() => {
                      if (lessons[id].length > 0)
                        navigate(`/courses/${id}/lessons/${lessons[id][0].id}`)
                    }}
                  >
                    <ViewCourseIcon />
                  </div>
                  :
                  <div
                    className="CardOverview"
                    onClick={() => navigate(`/course/overview/${id}`)}
                  >
                    <OverviewIcon />
                  </div>
                }
              </div>
            </div>
            <div className="CardTitle">{title}</div>
            <div className="CardAuthorInfoContainer">
              <div
                style={{
                  backgroundImage: `url(${author_profile_image_url || placeholderImage})`
                }}
                className="CardAurthorProfileImg"
              />
              <div className="CardAuthorInfo">
                <div className="CardAuthorName">
                  <span>By</span>
                  <span>{author_name}</span>
                </div>
                <div className="CardDate">
                  {pretty_created_at.split(".").join("-")}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })
  )
}

function EmployeeDashboard() {
  useEffect(() => document.body.style.backgroundColor = "#F5F5F5", []);
  useLayoutEffect(() => { return () => document.body.style.backgroundColor = null }, []);
  return (
    <div className="EmployeeDashboardMainContainer">
      <Sidebar />
      <Navbar />
      <div className="EmployeeHeroContainer">
        <div className="EmployeeHero">
          <div className="EmployeeHeroImage" />
          <div className="EmployeeHeroHeader">
            Online Growth & Exit Master Classes
          </div>
          <div className="EmployeeHeroInfo">
            M&A Insights and practical strategies for business owners
          </div>
        </div>
        <div className="EmployeeDashboardCoursesContainer">
          <div className="EmployeeDashboardCourses">
            <EmployeeCourses />
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmployeeDashboard;
